"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 18';

var Unlock = function Unlock() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M6.74527778,12.982 C7.63894444,12.982 8.37083333,12.2589231 8.37083333,11.3743077 C8.37083333,10.4904615 7.63894444,9.76661538 6.74527778,9.76661538 C5.85161111,9.76661538 5.11972222,10.4904615 5.11972222,11.3743077 C5.11972222,12.2589231 5.85161111,12.982 6.74527778,12.982 Z M11.6219444,5.74892308 L10.8091667,5.74892308 L10.8091667,4.14123077 C10.8091667,1.92276923 8.98838889,0.122 6.74527778,0.122 C4.50216667,0.122 2.68138889,1.92276923 2.68138889,4.14123077 L4.22605556,4.14123077 C4.22605556,2.76661538 5.35616667,1.64969231 6.74527778,1.64969231 C8.13516667,1.64969231 9.2645,2.76661538 9.2645,4.14123077 L9.2645,5.74892308 L1.86861111,5.74892308 C0.974944444,5.74892308 0.244611111,6.472 0.244611111,7.35661538 L0.244611111,15.3935385 C0.244611111,16.2773846 0.974944444,17.0012308 1.86861111,17.0012308 L11.6219444,17.0012308 C12.5156111,17.0012308 13.2467222,16.2773846 13.2467222,15.3935385 L13.2467222,7.35661538 C13.2467222,6.472 12.5156111,5.74892308 11.6219444,5.74892308 Z M1.86938889,15.3935385 L11.6219444,15.3935385 L11.6219444,7.35661538 L1.86938889,7.35661538 L1.86938889,15.3935385 Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Unlock, {
  viewBox: viewBox
});

exports["default"] = _default;